// PagerBar.jsx — SB-159（第三百八十二批）：可复用的翻页器（范围一句 + 上一页／下一页）。
//
// SB-159 §2.2 当时就说「催升面一做就有了后面几处要用的翻页组件」，这就是那一只。它**不算数**：
// 范围文本（「第 a–b 条，共 N 条」）与能不能翻由调用方的纯函数给（pages/adminEscalations.mjs 的
// escalationPager、pages/adminLogs.mjs 的 pageInfo），这里只渲染——SB-042：`.jsx` 里不放判据。
import { Button, Stack, Typography } from '@mui/material';

export default function PagerBar({ text, hasPrev, hasNext, onPrev, onNext, prevLabel, nextLabel }) {
  return (
    <Stack direction="row" spacing={1} useFlexGap sx={{ alignItems: 'center', flexWrap: 'wrap' }} data-pager>
      <Typography variant="body2" color="text.secondary" data-pager-range>{text}</Typography>
      <Button size="small" disabled={!hasPrev} onClick={onPrev}>{prevLabel}</Button>
      <Button size="small" disabled={!hasNext} onClick={onNext}>{nextLabel}</Button>
    </Stack>
  );
}
